import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy
} from "@angular/core";
import { GridColumnDefinition } from "../../grid-column-definition";
import { CompositeFilterDescriptor, FilterDescriptor, isCompositeFilterDescriptor } from "@progress/kendo-data-query";
import { FilterService } from "@progress/kendo-angular-grid";
import { PickListProperties } from "../../picklist-properties";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { PicklistService } from 'src/app/shared/picklist/picklist.service';


@Component({
  standalone: false,
  selector: "app-filter-menu",
  templateUrl: "./filter-menu.component.html",
  styleUrls: ["./filter-menu.component.css"]
})
export class PicklistFilterMenuComponent implements OnInit, OnDestroy {
  @Input() public column: GridColumnDefinition;
  @Input() public filter: CompositeFilterDescriptor;
  @Input() public filterService: FilterService;
  @Input() public project: string;
  public currentSelection: (FilterDescriptor | CompositeFilterDescriptor)[];
  @Input() public picklistProperties: PickListProperties;
  public newCompositeFilter: CompositeFilterDescriptor;
  public dictionary: {
    [id: string]: boolean;
  } = {};

  @Output() filterChange: EventEmitter<
    CompositeFilterDescriptor
  > = new EventEmitter();

  private _destroy$ = new Subject<void>();

  constructor(private picklistService: PicklistService) {}

  ngOnInit() {
    if (this.picklistProperties) {
      for (
        let index = 0;
        index < this.picklistProperties.Values.length;
        index++
      ) {
        this.dictionary[
          this.picklistProperties.Values[index].Value
        ] = false;
      }
      this.processInputFilters(this.filter);
    } else if (this.column.IsPicklistColumn) {
      if (this.project) {
      this.picklistService
        .getPicklistValuesForProject(this.column.PicklistGroupId, this.project)
        .pipe(takeUntil(this._destroy$))
        .subscribe(x => {
          this.picklistProperties = x;
          for (
            let index = 0;
            index < this.picklistProperties.Values.length;
            index++
          ) {
            this.dictionary[
              this.picklistProperties.Values[index].Value
            ] = false;
          }
          this.processInputFilters(this.filter);
        });
      } else {
        this.picklistService
        .getPicklistValues(this.column.PicklistGroupId)
        .pipe(takeUntil(this._destroy$))
        .subscribe(x => {
          this.picklistProperties = x;
          for (
            let index = 0;
            index < this.picklistProperties.Values.length;
            index++
          ) {
            this.dictionary[
              this.picklistProperties.Values[index].Value
            ] = false;
          }
          this.processInputFilters(this.filter);
        });
      }
    }
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  modelChanged(change: any, item: any) {

    this.filter.filters = Array<FilterDescriptor>();
    this.filter.logic = "or";

    for (
      let index = 0;
      index < this.picklistProperties.Values.length;
      index++
    ) {
      const element = this.picklistProperties.Values[index];
      if (this.dictionary[element.Value]) {
        const newfilter: FilterDescriptor = {
          field: this.column.PropertyName,
          ignoreCase: false, // Might need to change if there is ever a use for this
          operator: "eq",
          value: element.Value
        };
        this.filter.filters.push(newfilter);
      }
    }
    this.newCompositeFilter.filters.push(this.filter);

    this.filterChange.emit(this.filter);
  }

  processInputFilters(filterItem: CompositeFilterDescriptor) {
    this.newCompositeFilter = {
      logic: "and",
      filters: []
    };
    for (let index = 0; index < filterItem.filters.length; index++) {
      const element = filterItem.filters[index];
      if (isCompositeFilterDescriptor(element)) {
        for (
          let innerIndex = 0;
          innerIndex < element.filters.length;
          innerIndex++
        ) {
          const innerElement = element.filters[innerIndex];
          if (isCompositeFilterDescriptor(innerElement)) {
            this.processInputFilters(innerElement);
          } else {
            if (innerElement.field === this.column.PropertyName) {
              this.dictionary[innerElement.value] = true;
            } else {
              this.newCompositeFilter.filters.push(element);
            }
          }
        }
      } else {
        if (element.field === this.column.PropertyName) {
          this.dictionary[element.value] = true;
        } else {
          this.newCompositeFilter.filters.push(element);
        }
      }
    }
  }

}
